<template>
  <div id="app">

    <Header 
    :curr='index' 
    :correct='correctAns'
    :total='totalAns'
    :reset='reset'
    />
    <br>
    <b-container class='container'>
    <b-row>
      <b-col sm='2'></b-col>
      <b-col sm='8'>
        <UserData 
          :start='start'
          v-if="questionsInput==''"
        />
        <img src='./assets/25.svg' v-if="!questions.length && questionsInput!=''" style='margin-top:50px;height:30%;width:30%'>
        <QuestionBox 
          v-if='questions.length'
          :CurrQuestion="questions[index]"
          :next="next"
          :increment='increment'
          :totalAns='totalAns'
          :index='index'
          :questionsInput='questionsInput'
        />
      </b-col>
      <b-col sm='2'></b-col>
    </b-row>
  </b-container>
    
  </div>
</template>

<script>
import Header from './components/Header.vue'
import QuestionBox from './components/QuestionBox.vue'
import UserData from './components/UserData.vue'

export default {
  name: 'App',
  components: {
    Header,
    QuestionBox,
    UserData
  },
  data(){
    return {
      questions : [],
      index: 0,
      correctAns:0,
      totalAns:0,
      selected:'',
      questionsInput:'',
    }
  },
  methods:{
    next:function(){
      this.index++;
    },
    reset:function(){
      this.questions = [];
      this.index= 0;
      this.correctAns=0;
      this.totalAns=0;
      this.selected='';
      this.questionsInput='';
    },
    increment:function(isCorrect){
      if(isCorrect)
      {
        this.correctAns++;
      }
    },
    start:function(questionNo,diff){
      this.questionsInput=questionNo;
      this.selected=diff;
      this.load();
    },
    load:function(){
      if(this.questionsInput!=''){
        
          fetch(`https://opentdb.com/api.php?amount=${this.questionsInput}&category=29&difficulty=${this.selected}&type=multiple`,{
            method:'get',
          })
          .then((response)=>{
            return response.json();
          })
          .then((jsonData)=>{
            this.questions=jsonData.results;
            this.totalAns=this.questions.length;
          })
        }
      },
    }
  }
  
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
